import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "../state/reducers/rootReducer";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;